export interface TrendGraphView {
    id?: string;
    name: string;
    description: string;
    channels: ChannelViewOption[];
    publicAccess: boolean;
}

export interface ChannelViewOption {
    fcuChannelId: number;
    color: string;
    name: string;
    channelId: string;
}

export const TrendGraphViewFns = {
    create,
};

export const MaxTrendGraphsError = 'Max Trend graphs limit reached';

function create(): TrendGraphView {
    return {
        name: '',
        description: '',
        channels: [],
        publicAccess: true,
    };
}
